module.exports = __webpack_public_path__ + "img/box5-05.563b3aec.png";